import moment from '../../../lib/moment.js'

export function generateDays(momentStart, momentEnd) {
  // create date items running from start to end
  const dates = []
  const run = moment(momentStart) // clone to run
  while (run.isBefore(momentEnd, 'day') || run.isSame(momentEnd, 'day')) {
    const snapshot = moment(run) // clone snapshot
    dates.push(snapshot)
    run.add(1, 'days')
  }
  return dates
}
export default {
  getGridDates: (_moment) => {
    const date = _moment || moment()
    const startDate = moment(date).date(1).day(0) // top left
    const endDate = moment(date).date(date.daysInMonth()).day(6) // bottom right
    return generateDays(startDate, endDate)
  },
  getTableDates: (_moment, range = 'month') => {
    const date = _moment || moment()
    let startDate
    let endDate
    if (range === 'month') {
      startDate = moment(date).date(1)
      endDate = moment(date).date(date.daysInMonth())
    } else if (range === 'week') {
      startDate = moment(date).day(0)
      endDate = moment(date).day(6)
    } else {
      startDate = moment()
      endDate = moment()
    }
    return generateDays(startDate, endDate)
  },
  getTableWeekDates: (_moment) => {
    const date = _moment || moment()
    const startDate = moment(date).day(1)
    const endDate = moment(date).day(7)
    return generateDays(startDate, endDate)
  },
  generateMetrolendarEventsMap: events => {
    const map = {}
    events.forEach(event => {
      const key = event.moment.format('YYYY-MM-DD')
      map[key] = map[key] || []
      map[key].push(event)
    })
    return map
  },
  generateMetrolendarEventsTableLookup: events => {
    const groups = {}
    events.forEach(event => {
      const group = groups[event.group] || { rows: {} }
      groups[event.group] = group
      group.id = event.group
      group.label = event.group_label

      const row = group.rows[event.row] || { map: {} }
      group.rows[event.row] = row
      row.id = event.row
      row.label = event.row_label

      if (event.moment !== undefined) {
        const key = event.moment.format('YYYY-MM-DD')
        const map = row.map[key] || { events: [] }
        row.map[key] = map
        map.events.push(event)
      }
    })
    return groups
  },
}



// WEBPACK FOOTER //
// ./src/components/timesheet/helpers/date.js